import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";

import {
  acceptConversationStart,
  getClosedConversation,
} from "redux/chats/chats.actions";
import FooterText from "./FooterText";
import TransferToMeWrapper from "components/Conversations/TransferToMeWrapper";

const getSelectedConversation = ({ chatsData }) =>
  chatsData.selectedConversation;

const getContainer = ({ userData }) => userData.container.data;

function PendingConvFooter({ convType }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectedConversation = useSelector(getSelectedConversation);
  const container = useSelector(getContainer);

  /* if user have had an accepepted conversation before and their
  account is not expired and just their remaining conersation count is zero then
  they can continue their conversation */
  const hasAgentConv = selectedConversation?.conversation?.chats?.some(
    (item) => item.me
  );

  const packageType = container?.package?.type;
  const userId = selectedConversation?.user?.id;
  const convId = selectedConversation.conversation.id;
  const convsChargeCount = +container?.account?.conversationCharge;

  const isFooterBarDisabled =
    packageType === "expire" || (convsChargeCount === 0 && !hasAgentConv);

  const handleAcceptConversation = () => {
    if (isFooterBarDisabled) return;

    dispatch(
      acceptConversationStart({
        convId,
        userId,
        navigate,
      })
    );
  };

  const renderFooter = (
    <div
      className="pending-conv-footer flex flex-jc-c w-100"
      data-disabled={isFooterBarDisabled}
    >
      <p>
        <FooterText hasAgentConv={hasAgentConv} convType={convType} />
      </p>
    </div>
  );

  const renderFooterBasedOnSelectConv = () => {
    if (convType === "otherConvs" && !isFooterBarDisabled) {
      return <TransferToMeWrapper>{renderFooter}</TransferToMeWrapper>;
    }

    return <div onClick={handleAcceptConversation}>{renderFooter}</div>;
  };

  return renderFooterBasedOnSelectConv();
}

export default PendingConvFooter;
